import React, { useState, useEffect, FC, JSX } from "react";
import { useAgent } from "../../context/AgentContext";
import CompanyManagementTable from "../../components/company/CompanyManagementTable";

const PendingCompanies: FC = (): JSX.Element => {
  const {
    pendingCompanies,
    loadingState,
    errorState,
    fetchPendingCompanies,
    updateCompanyVerificationStatus,
  } = useAgent();

  // useEffect(() => {
  //   fetchPendingCompanies();
  // }, []);

  return (
    <CompanyManagementTable
      companies={pendingCompanies}
      loading={loadingState.pendingCompanies}
      error={errorState.pendingCompanies}
      onRefresh={fetchPendingCompanies}
      onUpdateVerificationStatus={updateCompanyVerificationStatus}
      isAdminView={false} // Agent view
      pageTitle="Pending Company Approvals"
      pageDescription="Review and approve company registrations"
      showFilter={false}
      showReviewGuidelines={true}
      showVerificationHistory={false} // Pending companies don't need history initially
    />
  );
};

export default PendingCompanies;
